/**
 * Target work date for copy-as-draft — quick presets + custom picker.
 */

import type { FC } from 'react';
import { Calendar } from 'lucide-react';

import { Button, Input } from '@/components/ui';
import { addDaysToIso, todayIsoDateParis } from '@/features/smswiser-campaigns/utils/dateFormat';

const INPUT_ID = 'copy-as-draft-target-date';

export interface CopyAsDraftTargetDateSectionProps {
  value: string;
  onChange: (isoDate: string) => void;
}

export const CopyAsDraftTargetDateSection: FC<CopyAsDraftTargetDateSectionProps> = ({ value, onChange }) => {
  const today = todayIsoDateParis();
  const tomorrow = addDaysToIso(today, 1);
  const isToday = value === today;
  const isTomorrow = value === tomorrow;

  return (
    <div className="flex flex-col gap-2">
      <span className="flex items-center gap-2 text-xs font-medium text-muted-foreground">
        <Calendar className="h-3.5 w-3.5 shrink-0" aria-hidden />
        Target work date
      </span>
      <div className="flex flex-wrap gap-2">
        <Button
          type="button"
          variant={isToday ? 'default' : 'outline'}
          size="sm"
          className="h-8"
          onClick={() => onChange(today)}
        >
          Today
        </Button>
        <Button
          type="button"
          variant={isTomorrow ? 'default' : 'outline'}
          size="sm"
          className="h-8"
          onClick={() => onChange(tomorrow)}
        >
          Tomorrow
        </Button>
      </div>
      <div className="space-y-1.5">
        <label htmlFor={INPUT_ID} className="text-xs font-medium text-foreground">
          Custom date
        </label>
        <Input
          id={INPUT_ID}
          type="date"
          className="h-10 w-full"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          aria-label="Target date for draft"
        />
      </div>
    </div>
  );
};
